import { inject, Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'safeHtml',
  standalone: true,
  pure: true
})
export class SafeHtmlPipe implements PipeTransform {
  #sanitizer = inject(DomSanitizer);

  transform(content: string): SafeHtml {
    if (!content || content.trim() === '') {
      return null;
    }
    return this.#sanitizer.bypassSecurityTrustHtml(content);
  }
}
